export default __webpack_public_path__ + "static/media/collections-java.f951414b.png";